(function(){
  var bar=document.querySelector('.kp-sk'); if(!bar) return;
  var box=document.querySelector('.bundle-v2'); if(!box){bar.remove();return;}
  bar.hidden=false;

  // best saving on the page drives the pill
  var best=0;
  document.querySelectorAll('.bundle-v2__save').forEach(function(el){
    var m=(el.textContent||'').match(/(\d+)\s*%/); if(m&&+m[1]>best) best=+m[1];
  });
  var slot=bar.querySelector('[data-kp-save]');
  if(best) slot.textContent=best+'%'; else slot.parentNode.textContent='FREE SHIPPING';

  bar.querySelector('.kp-sk__btn').addEventListener('click',function(){
    var t=document.querySelector('.bundle-v2__title')||box;
    window.scrollTo({top:t.getBoundingClientRect().top+window.scrollY-72,behavior:'smooth'});
  });

  var footer=document.querySelector('footer')||document.querySelector('.footer');
  function tick(){
    var b=box.getBoundingClientRect();
    var past=b.bottom<80;                       // buy box scrolled away
    var atEnd=footer? footer.getBoundingClientRect().top<window.innerHeight : false;
    bar.setAttribute('data-show',(past&&!atEnd)?'1':'0');
  }
  addEventListener('scroll',tick,{passive:true});
  addEventListener('resize',tick,{passive:true});
  tick();

  })();
/* subscribe / one-time switch, wired to the theme's own toggle - all widths */
(function(){
  var box=document.querySelector('.bundle-v2'); if(!box) return;
  var areas=box.querySelectorAll('.bundle-v2__area'), tog=box.querySelector('.bundle-v2__toggle');
  if(areas.length!==2||!tog) return;
  var tabs=document.createElement('div'); tabs.className='kp-tabs';
  tabs.innerHTML='<button type="button" data-i="0">Subscribe &amp; save</button><button type="button" data-i="1">One-time</button>';
  areas[0].parentNode.insertBefore(tabs,areas[0]);
  function subOn(){return !areas[0].classList.contains('bundle-v2__area--hidden');}
  function sync(){var s=subOn();
    tabs.children[0].setAttribute('aria-pressed',s?'true':'false');
    tabs.children[1].setAttribute('aria-pressed',s?'false':'true');}
  tabs.addEventListener('click',function(e){
    var b=e.target.closest('button'); if(!b) return;
    if((b.dataset.i==='0')!==subOn()) tog.click();
    sync();
  });
  new MutationObserver(sync).observe(areas[0],{attributes:true,attributeFilter:['class']});
  sync();
})();
/* dog illustrations: the FAQ trio and the closing row, as in the demo.
   width/height are set so the browser reserves the space and they do not pop in. */
(function(){
  var CDN='https://kelpie.com/cdn/shop/files/';
  function sectionWith(re){
    var all=[].slice.call(document.querySelectorAll('.shopify-section'));
    for(var i=0;i<all.length;i++){
      var h=all[i].querySelector('h1,h2,h3,h4,.h1,.h2,.h3');
      if(h&&re.test(h.textContent.replace(/\s+/g,' ').trim())) return all[i];
    }
    for(var j=0;j<all.length;j++){
      var t=all[j].textContent.replace(/\s+/g,' ').trim();
      if(re.test(t.slice(0,120))) return all[j];
    }
    return null;
  }
  function add(sec,cls,src,w,h){
    if(!sec||sec.querySelector('.'+cls)) return;
    var host=sec.querySelector('.section')||sec;
    var img=document.createElement('img');
    img.className=cls; img.src=src; img.alt='';
    img.setAttribute('width',w); img.setAttribute('height',h);
    img.loading='lazy'; img.decoding='async';
    host.appendChild(img);
  }
  function place(){
    add(sectionWith(/Frequently Asked Questions/i),'kp-faqdogs',CDN+'Group_61579.svg',220,114);
    add(sectionWith(/^Kelpie Happiness Guarantee/i),'kp-dogrow',CDN+'Asset_2_1_1.webp?width=900',1116,221);
  }
  place();
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',place);
  addEventListener('load',place);
})();

/* product-recommendations reserves ~714px of padding around nothing when the theme's
   IntersectionObserver never fires. Fetch the section ourselves; hide it only once we
   know the endpoint has nothing to show (hiding it first would stop the observer forever). */
(function(){var pr=document.querySelector('product-recommendations');if(!pr)return;
var done=false;
function fill(){if(done)return;if(pr.querySelector('a[href*="/products/"]'))return;done=true;
var lim=((pr.dataset.url||'').match(/limit=(\d+)/)||[0,4])[1];
var u='/recommendations/products'+String.fromCharCode(63)+'limit='+lim+'&product_id='+pr.dataset.productId+'&intent='+(pr.dataset.intent||'related')+'&section_id='+pr.dataset.sectionId;
fetch(u).then(function(r){return r.text()}).then(function(t){
var el=new DOMParser().parseFromString(t,'text/html').querySelector('product-recommendations');
var sec=pr.closest('.shopify-section')||pr;
if(el&&el.querySelector('a[href*="/products/"]')){pr.innerHTML=el.innerHTML;pr.setAttribute('data-recommendations-performed','true')}
else{sec.style.display='none'}
}).catch(function(){});}
setTimeout(fill,1200);addEventListener('load',function(){setTimeout(fill,600)});})();

/* Loox renders 20 reviews in one mobile column = 5,742px, taller than the rest of the page.
   The block setting lives in templates/product.json, which Fresh Breath shares, so set it here
   instead — this file only loads on Relief and Calm. Loox reads data-limit off #looxReviews and
   stamps data-upgraded when it has built the frame, so winning that race costs no extra fetch;
   the observer is the fallback for when it does not. */
(function(){var LIM='6';function el(){return document.getElementById('looxReviews')}
function set(){var e=el();if(!e)return false;if(e.getAttribute('data-limit')!==LIM)e.setAttribute('data-limit',LIM);return true}
set();
function frame(){var f=document.getElementById('looxReviewsFrame');if(!f||!f.src)return;
if(/[?&]limit=(\d+)/.test(f.src)&&RegExp.$1!==LIM){f.src=f.src.replace(/([?&]limit=)\d+/,'$1'+LIM)}}
var e=el();if(e){new MutationObserver(function(m,o){if(el()&&el().getAttribute('data-upgraded')){frame();o.disconnect()}})
.observe(e,{attributes:true,childList:true,subtree:true});}
document.addEventListener('DOMContentLoaded',set);addEventListener('load',function(){set();setTimeout(frame,1500)});})();
